function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#32C7C7;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#0B60B9;}\n\t.st3{fill:#D66A05;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("circle", {
  className: "st2",
  cx: 108,
  cy: 108,
  r: 84
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M50.4,161.5l-2.3-2.6C35.8,144.6,29,126.3,29,107.5C29,64.2,64.2,29,107.5,29S186,64.2,186,107.5 c0,17.8-5.8,34.5-16.8,48.5l-2.2,2.7l-1.9-2.9c-12.7-19.6-33.6-31.3-55.7-31.3c-23.3,0-44.7,12.7-57.3,34L50.4,161.5z M107.5,34 C67,34,34,67,34,107.5c0,16.5,5.6,32.5,15.7,45.4c13.7-21,35.8-33.4,59.8-33.4c22.7,0,44.1,11.4,57.8,30.6 c8.9-12.5,13.7-27.2,13.7-42.6C181,67,148,34,107.5,34z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M107,123c-19.9,0-36-16.1-36-36c0-15.7,10.2-29.5,25-34.3v-7.9c0-2.1,1.7-3.8,3.8-3.8h14.3 c2.1,0,3.8,1.7,3.8,3.8v7.9c14.8,4.7,25,18.6,25,34.3C143,106.9,126.9,123,107,123z M101,46v10.5L99.1,57C85.5,60.6,76,72.9,76,87 c0,17.1,13.9,31,31,31s31-13.9,31-31c0-14.1-9.5-26.4-23.1-30l-1.9-0.5V46H101z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M148,90H62.5c-1.6,0-3-1.3-3-3v-3.5c0-1.7,1.3-3,3-3H148c1.6,0,3,1.3,3,3V87C151,88.7,149.6,90,148,90z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M113,64.5V46.4c0-1.4,1.1-2.5,2.5-2.5l0,0c1.4,0,2.5,1.1,2.5,2.5v18.1c0,1.4-1.1,2.5-2.5,2.5l0,0 C114.1,67,113,65.9,113,64.5z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M96,64.5V46.4c0-1.4,1.1-2.5,2.5-2.5l0,0c1.4,0,2.5,1.1,2.5,2.5v18.1c0,1.4-1.1,2.5-2.5,2.5l0,0 C97.1,67,96,65.9,96,64.5z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M124.5,67L124.5,67c-1.4,0-2.5-1.1-2.5-2.5v-6c0-1.4,1.1-2.5,2.5-2.5l0,0c1.4,0,2.5,1.1,2.5,2.5v6 C127,65.9,125.9,67,124.5,67z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M90.5,67L90.5,67c-1.4,0-2.5-1.1-2.5-2.5v-6c0-1.4,1.1-2.5,2.5-2.5l0,0c1.4,0,2.5,1.1,2.5,2.5v6 C93,65.9,91.9,67,90.5,67z"
})));

var SvgProfileWorker = function SvgProfileWorker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212 208",
    style: {
      enableBackground: "new 0 0 212 208"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfileWorker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-worker.7ea6d747.svg";
export { ForwardRef as ReactComponent };